// @flow
import React, {Component} from 'react'
import {connect} from 'react-redux'
import {formActions, appSelectors, uiActions} from '@/store'
import type {Language} from '@/types'
import {exampleCSVLink, exampleXLSLink} from '@/defaults'
import ExpandCollapse from '@/elements/expand-collapse-panel'
import UploadManualForm from './upload-manual-form'
import './upload-file.css'
import {isEmpty} from 'ramda'

type Props = {
  l: Language,
  storeFormField: (any) => void,
  type: string,
  onConfirm: ?(string) => void,
  modalError: ?string,
  formData: ?Object,
  confirmMessage: string,
  closeModal: () => void,
  clearForm: () => void,
}

const initialState = {
  error: false,
  fileName: '',
}

type State = {
  error: boolean,
  fileName: string,
}

const fileType = ['text/csv', 'text/x-csv', 'application/x-csv', 'application/csv',
  'text/x-comma-separated-values', 'text/comma-separated-values', 'application/vnd.ms-excel',
  'application/vnd.ms-excel', 'application/msexcel', 'application/x-msexcel',
  'application/x-ms-excel', 'application/x-excel', 'application/x-dos_ms_excel',
  'application/xls', 'application/x-xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']

export class UploadFileForm extends Component<Props, State> {
  manualUploadTrigger: ?any

  constructor (props: Props) {
    super(props)
    this.state = initialState
  }

  setManualUploadTrigger = (triggerNode: any) => {
    this.manualUploadTrigger = triggerNode
  }

  collapseManualUpload = () => {
    if (this.manualUploadTrigger) {
      this.manualUploadTrigger.click()
    }
  }

  getClassName () {
    let name = 'input-file-wrapper'
    if (this.state.fileName) {
      name += ' upload-success'
    }
    if (this.state.error) {
      name += ' upload-error'
    }
    return name
  }

  onClose = () => {
    this.props.clearForm()
    this.props.closeModal()
  }

  onConfirm = (type: string) => () => {
    if (this.props.onConfirm) {
      this.props.onConfirm(type)
    }
    // to make sure that the  api call return
    const modalInterval = setInterval(() => {
      if (isEmpty(this.props.modalError) && !isEmpty(this.props.confirmMessage)) {
        this.onClose()
        clearInterval(modalInterval)
      }
    }, 500)
  }

  renderCancel = () => (
    <button className='btn btn-danger' onClick={this.onClose}>
      {this.props.l('Cancel')}
    </button>
  )

  renderConfirm = () => (
    <button
      className='btn btn-success'
      disabled={!this.props.formData || !this.props.formData.file}
      onClick={this.onConfirm('file')}
    >
      {this.props.l('Confirm')}
    </button>
  )

  renderFooter = () => {
    // manual upload is only for import currently
    // if in future manual upload for sync is needed just check for 'import' text in all files
    // and just remove code used for 'sync'
    return <span>
      <div className="upload-file-footer">
        {this.renderCancel()}
        {this.renderConfirm()}
      </div>
      {
        this.props.type === 'import' ? <ExpandCollapse setTriggerRef={this.setManualUploadTrigger}
          heading={this.props.type === 'import' ? 'Manual Import' : 'Manual Sync'}
          l={this.props.l}>
          <hr className='manual-upload-line-break'/>
          <UploadManualForm type={this.props.type} onConfirm={this.onConfirm('manual')}
            collapseManualUpload={this.collapseManualUpload}/>
        </ExpandCollapse> : null
      }
    </span>
  }

  render = () =>
    <div className='upload-data-ctr'>
      <p className='text-center'>{this.props.l('Upload a supported file (.csv, .xls or .xlsx) in the same format as the sample')}</p>
      <p className='text-center'>{this.props.l('Safe Number, Company Number, Country Code, Personal Reference, Notes, Personal Limit.')}</p>
      <p className='text-center'>{this.props.l('Each row must contain either:')}</p>
      <div className='list-center'>
        <p className='show-list'><li>{this.props.l('Safe Number')}</li></p>
        <p className='show-list'><li>{this.props.l('Company Number and Country Code')}</li></p>
      </div>
      {this.state.error ? <p className='error-message text-center'>{this.props.l('Please upload a .csv/.xls/.xlsx file')}.</p> : null}
      <p>
        <a className={this.getClassName()}>
          <input
            type="file"
            title=" "
            onChange={(e) => {
              let files = e.currentTarget.files
              if (files.length > 0 && fileType.indexOf(files[0].type) > -1) {
                this.setState({
                  error: false,
                  fileName: files[0].name,
                })
                this.props.storeFormField({file: files[0]})
              } else {
                this.setState({
                  error: true,
                  fileName: files[0] ? files[0].name : '',
                })
                this.props.storeFormField({file: null})
              }
            }}
          />
          <span className='btn-text'>{this.props.l('Choose file')}{this.state.fileName ? ` - ${this.state.fileName}` : ''}</span>
        </a>
      </p>
      <div className='buttons-container'>
        <div className='show-sample-buttons'>
          <a className='btn btn-default btn-block download-btn' href={exampleCSVLink}>{this.props.l('Download sample (.csv)')}</a>
        </div>
        <div className='show-sample-buttons'>
          <a className='btn btn-default btn-block download-btn' href={exampleXLSLink}>{this.props.l('Download sample (.xlsx)')}</a>
        </div>
      </div>
      {this.renderFooter()}
    </div>
}
const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
  modalError: state.ui.modal.error,
  formData: state.form.data,
  confirmMessage: state.ui.confirm.message,
})

export default connect(
  mapStateToProps,
  {...formActions, ...uiActions},
)(UploadFileForm)



// WEBPACK FOOTER //
// ./src/views/forms/upload-file.js